/**
 * How to add a new Component
 * 
 *  1. Type the name of the component, in camelCase – If the file is in snake-case
 *  2. If the name of the component, and file name is the same, create an object with { name: 'componentName', file: 'componentName' }
 * 
 */

export const components = [
    'header',
    'announcementBar',
    'mobileMenu',
    'mobileBrandList',
    'footer',
    'newsletterForm',
    'cartDrawer',
    'cartDrawerItem',
    'cartPage',
    'cartTermsPopup',
    'productSelection',
    'productBrandLogo',
    'productBrandDescription',
    'productTabs',
    'productRecentlyViewed',
    'productRecommended',
    'uspSection',
    'testimonials',
    'brandLogos',
    'cartValidation',
    'customerLogin',
    'customerAddresses',
    'customerAddressForm',
    'productImage',
    'brandsPage',
    'faqPage',
    'newsletter',
    'textPage',
    'collectionTitle',
    'collectionFilterPrice',
    'collectionMain',
    'collectionNav',
    'search',
    'searchPage',
    'genderSelection',
    'mobileHeader',
    'collectionHeader',
    'clerkProducts',
    'featureSlider'
]

export const state = {
    cartOpen: false,
}